import React from 'react';
import '../WineryProducts.css'
import { useTranslation } from 'react-i18next';
import Bio_bordo_3 from '../../assets/images/Bio_bordo_3.png'
import './Bio.css'
function Bio() {
  const { t } = useTranslation();
   
  const products = [
  
    {
        name: t('ICEgum LIQUID'),
        description: t('Organic gum arabic in liquid form.'),
      },
      {
        name: t('ICEtan BIO-V tannin'),
        description: t('Proanthocyanidin tannin from 100% natural grape seeds, extracted according to organic methodology and certified organic.The total absence of chemical residues on the grapes, the particular extraction process without the use of any chemical solvent allows us to obtain tannin from grape seeds free from bitter notes, certified organic. Indicated for the color stabilization of wines and to give structure during the refinement period. Its repeated use during the various phases, from vinification to refinement, allows the quantities of sulfur dioxide to be reduced.'),
      },
      {
        name: t('ICEtan BIO-C tannin'),
        description: t('100% natural ellagic tannin extracted according to organic methods from Castanea sativa wood. Indicated for inhibiting oxidase enzymes in grapes that are not particularly healthy and for protecting the chromatic fraction in wines. We recommend using it in the processing of organic red grapes. The use of small dosages during decanting helps to limit the use of sulfur dioxide.'),
      },
      {
        name: t('ICEtan BIO-STAB tannin'),
        description: t('Blend of 100% natural ellagic tannins and proanthocyanidins from organic crops. Its use right from the early stages of refinement contributes to the protection of anthocyanins from oxidation and favors the formation of stable bonds. The condensed tannins present give a complete and perfectly balanced gustatory perception which allows the tannic structure of the wines to be regulated during refinement. The use of small dosages during decanting helps to limit the use of sulfur dioxide.'),
      },
      {
        name: t('ICEferm NATURA ATTIVA activator'),
        description: t('Fermentation activator based on Saccharomyces cerevisiae yeast autolysate in dried, certified organic form.'),
      },
      {
        name: t('LIOZIMAS Natura DUE yeast'),
        description: t('Fresh culture in liquid form of Saccharomyces cerevisiae yeast cells (phenotypic and genotypic identification periodically checked) indicated for the fermentation of red grape varieties.'),
      },
      {
        name: t('LIOZIMAS Natura UNO yeast'),
        description: t('Fresh culture in liquid form of Saccharomyces cerevisiae yeast cells (phenotypic and genotypic identification periodically checked) indicated for the fermentation of white grape varieties.'),
      },
     
  
  ];

  return (
    <>
          <div className='mainBioImg'>
      <div className='bioImg1'></div>


      <div className="bioImg2">
  <h1 className="bioTitle">{t("BIO Products")}</h1>
  <img src={Bio_bordo_3} alt="BIO Products" />
</div>


    </div>
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          {/* <img src={product.image} alt={product.name} /> */}
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
    </>
  );
}

export default Bio;
